/**
 * Pushes the git server's hook reported, as the board socket delivered them
 * (admins only — the tmux view's git panel is theirs). Module-level, like
 * lib/repoSettings.ts: the socket lives in the board store, the panel only
 * while the tmux view is open, and a push that lands between the two opening
 * should still be in the feed.
 */
import { ref } from "vue";
import type { GitPush } from "@shared/gitGraph.js";

/** How many pushes are kept, newest first, across every repo. */
const KEEP = 50;

export const gitPushes = ref<GitPush[]>([]);

export function gitPushed(push: GitPush): void {
  gitPushes.value = [push, ...gitPushes.value].slice(0, KEEP);
}
